export default __webpack_public_path__ + "static/media/calendar.39f67bf1.svg";